<template>
	<img src="@/assets/knowbe4.svg"/>
</template>

<script>
	export default {
		name: "KnowBe4",
	}
</script>

<style scoped>
	img {
		position: absolute;
		top: 42px;
		left: 42px;
		height: 80px;
		z-index: 1;
	}
</style>
